import 'pickadate/lib/picker.date';

/**
 * Datepicker - applies date-picker to inputs
 */
function $datepicker (element, pickerOptions) {

    pickerOptions = pickerOptions || {};

    var $input = $(element);

    const opt = {
        'default': {
            /** Translation: de_DE */
            monthsFull: [ 'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember' ],
            monthsShort: [ 'Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez' ],
            weekdaysFull: [ 'Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag' ],
            weekdaysShort: [ 'So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa' ],
            today: 'Heute',
            clear: 'Löschen',
            close: 'Schliessen',
            firstDay: 1,
            format: 'yyyy-mm-dd',
            formatSubmit: 'yyyy-mm-dd',
            hiddenSuffix: 'date',

            /** Settings **/
            min: true // disable past dates
        }
    };


    return $input.each(function () {
        var $this = $(this),
            options = opt['default'];

        $this.pickadate($.extend(true, {}, options, pickerOptions));
    });

}

export default $datepicker;



// WEBPACK FOOTER //
// ./src/js/app/components/datepicker.js